import React from 'react';
import { ObjectFieldTemplateProps } from '@rjsf/core';
import { Segment } from 'semantic-ui-react'
import { useSchemaTranslation } from '../../../../../sg-schema/useSchemaTranslation';
import { EEvaluationStatus } from '../../../../interfaces/IEvaluation';

const EvaluationObjectTemplate = (props: ObjectFieldTemplateProps) => {
    const {
        DescriptionField,
        description,
        TitleField,
        title,
        properties,
        required,
        uiSchema,
        idSchema,
        formContext,
    } = props;
    const { t } = useSchemaTranslation();
    const observationForm = uiSchema["ui:observationFormReference"];

    const propertiesWithValue = properties.filter((property) => {
        const props = property.content.props
        const isEmptyValue = (!props.formData || !props.formData.status) || (props.formData.status === EEvaluationStatus.Uknown && typeof props.formData.okay === "undefined" && typeof props.formData.notOkay === "undefined")
        return formContext.hideUknownEvaluationChecks === true ? !isEmptyValue : true
    });

    if (!propertiesWithValue.length) {
        return null
    }

    return (
        <div className="EvaluationObjectTemplate-container">
            {(uiSchema['ui:title'] || title) && (
                <TitleField
                    id={`${idSchema.$id}-title`}
                    title={t(title)}
                    required={required}
                    //@ts-ignore
                    headerProps={{
                        className: "EvaluationObjectTemplate-title ObjectFieldTemplate-title",
                        ...(uiSchema["ui:header"] || {})
                    }}


                />
            )}
            {description && (
                <DescriptionField
                    id={`${idSchema.$id}-description`}
                    description={t(description)}
                />
            )}
            <div className="EvaluationObjectTemplate-segments">
                {properties.map((element: any, index) => {
                    const props = element.content.props

                    if (!props.uiSchema["ui:observationFormReference"]) {
                        element.content.props.uiSchema["ui:observationFormReference"] = observationForm;
                    }

                    return (
                        <Segment className="EvaluationObjectTemplate-segment" key={index} vertical>
                            {element.content}
                        </Segment>
                    )
                })}
            </div>

        </div>
    );
};

export default EvaluationObjectTemplate;
